/**
 * Pick the properties from an object.
 */
export function pick<T extends object>(obj: T, keys: string[]): Partial<T> {
    if (typeof obj !== 'object') {
        throw new Error('pick() expects an object as the first argument');
    }

    const result = {} as Partial<T>;
    for (const key of keys) {
        if (key.includes('.')) {
            throw new Error('nested properties are not supported in pick()');
        }

        if (key in obj) {
            result[key] = obj[key];
        }
    }
    return result;
}
